import { render, staticRenderFns } from "./PageAddressesCreate.vue?vue&type=template&id=2fea9380&scoped=true&"
import script from "./PageAddressesCreate.vue?vue&type=script&lang=ts&"
export * from "./PageAddressesCreate.vue?vue&type=script&lang=ts&"
import style0 from "./PageAddressesCreate.vue?vue&type=style&index=0&id=2fea9380&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fea9380",
  null
  
)

export default component.exports